import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './lib/auth';

// Lazy load components for code splitting
const LoginForm = lazy(() => import('./components/auth').then(m => ({ default: m.LoginForm })));
const ManagerLayout = lazy(() => import('./app/manager/ManagerLayout').then(m => ({ default: m.ManagerLayout })));
const ViewerLayout = lazy(() => import('./app/viewer/ViewerLayout').then(m => ({ default: m.ViewerLayout })));

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Login Route */}
        <Route path="/login" element={<LoginForm />} />
        
        {/* Manager Routes (Protected) */}
        <Route
          path="/manager/*"
          element={
            <ProtectedRoute>
              <ManagerLayout />
            </ProtectedRoute>
          }
        />
        
        {/* Staff Viewer Routes (Token-based, handled in ViewerLayout) */}
        <Route path="/viewer" element={<ViewerLayout />} />
        <Route path="/viewer/:venueId/*" element={<ViewerLayout />} />
        
        {/* Default redirect to manager */}
        <Route path="/" element={<Navigate to="/manager" replace />} />
        
        {/* 404 fallback */}
        <Route path="*" element={<div className="p-8 text-center">Page not found</div>} />
      </Routes>
    </Suspense>
  );
}

export default App;
